import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { paths } from "../../Routes";
import { developOptions } from "../../config/developOptions";
import { ApplicationView } from "./ApplicationView";
import { NotFoundView } from "./NotFoundView";

export function TestApplicationView() {
  useEffect(() => {
    developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH = true;
    developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES = true;
    developOptions.USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS = true;
  }, []);
  const { loanId } = useParams();
  const startPath = `${paths.TestApplication}/${loanId}`;
  return (
    <>
      {developOptions.ALLOW_TEST_APPLICATION_VIEW ? (
        <ApplicationView
          loanId={loanId}
          forceDevOptionsPanel={true}
          startPath={startPath}
        />
      ) : (
        <NotFoundView />
      )}
    </>
  );
}
